import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { RequiredLabel, InlineWarning, dateUtilities, errorUtilities } from '../../../common';
import styleable from 'react-styleable';
import defaultStyle from './date-element.style.js';
import { DayPickerSingleDateController, toMomentObject  } from 'react-dates';
import { getCurrentValue } from '../text-input';
import 'react-dates/lib/css/_datepicker.css';

const formatDescriptionNVDA = "enter a date of format month, /day, /year";

export class DateElement extends Component {
  constructor(props){
    super(props);

    this.state = {
        showCalendar: false,
        inFocus: false
    }
  }

  dateValue() {
    const { response, defaultValue } = this.props;
    return getCurrentValue(response, defaultValue);
  }

  handleInput(e) {
    const { onChange } = this.props;
    const value = e.target.value;
    var dateInputsOnly = value.replace(/[^0-9/]/g, '');
    onChange(dateInputsOnly);
  }

  handleBlur(e) {
    e.preventDefault();
    this.setState({
      inFocus: false
    });
  }

  handleFocus(e){
    e.preventDefault();
    this.setState({
      inFocus: true,
      showCalendar: false
    });
  }

  toggleCalendar(show) {
    this.setState({showCalendar: show});
  }

  // Functions for DayPickerSingleDateController
  handleDayClicked(value) {
    const { onChange } = this.props;
    const dateString = value && value.format('MM/DD/YYYY');
    onChange(dateString);
  }

  isDayBlocked(value) {
    const { minDate, maxDate } = this.props;
    const dateString = value && value.format('MM/DD/YYYY');

    return !dateUtilities.isDateInRange(dateString, minDate, maxDate);
  }

  render() {
    const { showCalendar, inFocus } = this.state;
    const { isRequired, hidden, label, tooltip, id, minDate, maxDate, response, disabled, readOnly, errors, showErrors, css } = this.props;
    const hasErrors = errors && errors.length > 0;
    const errorIds = errors && errors.map(error => error.id + ' ');
    const inlineErrors = errors && errors.filter(err => err.type === errorUtilities.errorTypes.inline);
    const moment = toMomentObject(this.dateValue());

    if(hidden) return null;

    return (
      <div className={css.group + ' validated-section'}>
        <RequiredLabel
          hasErrors={hasErrors && showErrors}
          htmlFor={id}
          content={label}
          tooltip={tooltip}
          isRequired={isRequired}
          css={{
            requiredLabel: css.label,
            requiredIndicator: css.requiredIndicator}}/>
        <span id="format" className="skip">{formatDescriptionNVDA}</span>
        <div className={css.dateWrapper}>
          <input
            id={id}
            type="text"
            className={css.date + ' validated-input'}
            disabled={disabled}
            readOnly={readOnly}
            min={minDate}
            max={maxDate}
            value={this.dateValue()}
            onChange={e => this.handleInput(e)}
            onFocus={e => this.handleFocus(e)}
            onBlur={e => this.handleBlur(e)}
            placeholder={"mm/dd/yyyy"}
            aria-required={isRequired}
            aria-invalid={hasErrors && showErrors}
            aria-describedby={errorIds + ' format'}/>
          <div
            role="button"
            tabIndex={-1}
            aria-hidden='true'
            className={css.calendarButton}
            disabled={disabled || readOnly}
            onClick={e => this.toggleCalendar(!showCalendar)}>
            <span className={css.calendarIcon}/>
          </div>
        </div>
        { showCalendar && !readOnly ? (
            <div className={css.calendarAnchor}>
              <div className={css.calendarWrapper}>
                <DayPickerSingleDateController
                  date={moment}
                  onDateChange={e => this.handleDayClicked(e)}
                  focused={showCalendar}
                  onFocusChange={e => this.toggleCalendar(e.focused)}
                  numberOfMonths={1}
                  isDayBlocked={e => this.isDayBlocked(e)}/>
              </div>
            </div>
            ) : null
        }
        {inlineErrors && !inFocus && inlineErrors.map(warn => (
          <InlineWarning key={warn.id} warn={!!response ? warn.errorMessage : null}/>
        ))}
      </div>
    );
  }
}

DateElement.propTypes = {
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  tooltip: PropTypes.string,
  id: PropTypes.any,
  minDate: PropTypes.string, // expecting mm/dd/yyyy format
  maxDate: PropTypes.string, // expecting mm/dd/yyyy format
  onChange: PropTypes.func.isRequired,
  response: PropTypes.string, // expecting mm/dd/yyyy format
  defaultValue: PropTypes.string, // expecting mm/dd/yyyy format
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  errors: PropTypes.object,
  showErrors: PropTypes.bool,
};

export default styleable(defaultStyle) (DateElement);

